import { Component, Input } from '@angular/core';

/**
   * Logger Factory
  
*/
@Component({
  selector: 'ute-empty-state',
  templateUrl: 'ute-empty-state.component.html'
})
export class UteEmptyState {
  @Input() icon: string;
  @Input() desc: string;

  constructor() {}

  ionViewDidLoad(){}
}


// WEBPACK FOOTER //
// ./src/app/components/commons/molecules/ute-empty-state/ute-empty-state.component.ts